import { useCallback, useEffect, useState } from 'react';

type UseAutoDetectStateOptions = {
  autoDetectComment?: boolean;
  autoDetectChat?: boolean;
  onUpdateComment?: (value: boolean) => void | Promise<void>;
  onUpdateChat?: (value: boolean) => void | Promise<void>;
};

export function useAutoDetectState({
  autoDetectComment,
  autoDetectChat,
  onUpdateComment,
  onUpdateChat,
}: UseAutoDetectStateOptions) {
  const [detectComment, setDetectComment] = useState(autoDetectComment ?? false);
  const [detectChat, setDetectChat] = useState(autoDetectChat ?? false);

  useEffect(() => {
    setDetectComment(autoDetectComment ?? false);
    setDetectChat(autoDetectChat ?? false);
  }, [autoDetectComment, autoDetectChat]);

  const updateDetectComment = useCallback(
    async (value: boolean) => {
      setDetectComment(value);
      await onUpdateComment?.(value);
    },
    [onUpdateComment],
  );

  const updateDetectChat = useCallback(
    async (value: boolean) => {
      setDetectChat(value);
      await onUpdateChat?.(value);
    },
    [onUpdateChat],
  );

  return {
    detectComment,
    detectChat,
    updateDetectComment,
    updateDetectChat,
  };
}
